import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Pictogram } from '@brandwatch/axiom-components';

import { getComponentById, getComponentPictogram } from '../../selectors';
import ImageWithFallback from '../ImageWithFallback.jsx';
import { useElementRatios } from '../../hooks';

const meaningfulUrlSvg = (id, h, w) => {
  if (!h || !w) return null;
  return `https://cdn.vizia.brandwatch.com/assets/thumbnails/meaningful/${id}/${id}-${h}_x_${w}.svg`;
};

const MeaningfulThumbnail = ({ src, pictogram }) => {
  return (
    <ImageWithFallback src={src} space="x0" width="100%">
      <Pictogram textColor="night" name={pictogram} size="70%" />
    </ImageWithFallback>
  );
};

MeaningfulThumbnail.propTypes = {
  src: PropTypes.string,
  pictogram: PropTypes.string
};

const SlidePickerItem = ({
  onClick,
  component_type_id,
  pictogram,
  parentRect
}) => {
  const [ref, { width, height }] = useElementRatios(parentRect);

  if (!component_type_id || !parentRect) {
    return null;
  }

  const src = meaningfulUrlSvg(component_type_id, height, width);

  let thumb;

  if (!src && !pictogram) {
    thumb = <div />;
  } else {
    thumb = <MeaningfulThumbnail src={src} pictogram={pictogram} />;
  }

  return (
    <div ref={ref} className="SlidePickerItem" onClick={onClick}>
      {thumb}
    </div>
  );
};

SlidePickerItem.propTypes = {
  onClick: PropTypes.func,
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  component_type_id: PropTypes.string,
  pictogram: PropTypes.string,
  parentRect: PropTypes.object
};

SlidePickerItem.defaultProps = {
  onClick: () => {}
};

const mapStateToProps = (state, props) =>
  Object.assign({}, getComponentById(state, props), {
    pictogram: getComponentPictogram(state, props)
  });

export default connect(mapStateToProps)(SlidePickerItem);
